import Typography from "@mui/material/Typography";
import { versionLabel } from "../domain/version";

/**
 * The last line of every page: which build you are looking at, and that it is
 * still beta.
 *
 * 🔑 On EVERY page, not only the landing page. The version matters most when
 * something is wrong, and the page someone is looking at when that happens is
 * whichever page broke — a version that lives only on the home page is one the
 * reporter has to navigate away to find, and the navigation may be the thing
 * that is broken.
 */
export function VersionLine() {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      component="p"
      data-testid="version-line"
      sx={{ display: "block", mt: 3, pb: 2 }}
    >
      {versionLabel()}
    </Typography>
  );
}
